/**
 * General Ledger permission keys used by the UI (catalog `gl.*` / `rpt.*`; legacy menus 14 Journal Voucher, 275 / 238
 * approvals, currency variances and the finance reports). The API checks the same keys.
 */
export const glPermissions = {
  voucherView: "gl.journal_voucher.view",
  voucherCreate: "gl.journal_voucher.create",
  voucherUpdate: "gl.journal_voucher.update",
  voucherPost: "gl.journal_voucher.post",
  voucherDelete: "gl.journal_voucher.delete",
  voucherReverse: "gl.journal_voucher.reverse",
  voucherImport: "gl.journal_voucher.import",
  voucherExport: "gl.journal_voucher.export",
  voucherPrint: "gl.journal_voucher.print",
  entryView: "gl.journal_entry.view",
  rateOverride: "gl.exchange_rate.override",
  fiscalYearView: "gl.fiscal_year.view",
  fiscalYearCreate: "gl.fiscal_year.create",
  fiscalYearClose: "gl.fiscal_year.close",
  fiscalYearReopen: "gl.fiscal_year.reopen",
  periodClose: "gl.period.close",
  periodReopen: "gl.period.reopen",
  recurringView: "gl.recurring_journal.view",
  recurringCreate: "gl.recurring_journal.create",
  recurringUpdate: "gl.recurring_journal.update",
  recurringDelete: "gl.recurring_journal.delete",
  recurringRun: "gl.recurring_journal.run",
  settingsView: "gl.ledger_settings.view",
  settingsUpdate: "gl.ledger_settings.update",
  revaluationView: "gl.currencies_variances.view",
  revaluationPost: "gl.currencies_variances.post",
  trialBalanceView: "rpt.trial_balance.view",
  trialBalancePrint: "rpt.trial_balance.print",
  statementView: "rpt.statement_of_account.view",
  statementPrint: "rpt.statement_of_account.print",
  journalReportPrint: "rpt.general_ledger_report.print",
  financialStatementsView: "rpt.financial_reports.view",
  financialStatementsPrint: "rpt.financial_reports.print",
  costCenterReportView: "rpt.revenue_report.view",
  costCenterReportPrint: "rpt.revenue_report.print",
  projectReportView: "rpt.finance_project_revenue.view",
  projectReportPrint: "rpt.finance_project_revenue.print",
  deletedVouchersView: "rpt.deleted_vouchers_report.view",
} as const;
